import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faGlobe } from "@fortawesome/free-solid-svg-icons";
// import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
// import { faSquareGithub } from "@fortawesome/free-brands-svg-icons";
import EditRoadRoundedIcon from "@mui/icons-material/EditRoadRounded";
import ArchitectureRoundedIcon from "@mui/icons-material/ArchitectureRounded";
import TravelExploreRoundedIcon from "@mui/icons-material/TravelExploreRounded";
import WebhookRoundedIcon from "@mui/icons-material/WebhookRounded";
import FlightTakeoffRoundedIcon from "@mui/icons-material/FlightTakeoffRounded";
import chatnexo from "../assets/Untitled design (10).png";
import chatnexofigma from "../assets/Black and Red Gradient Glow Neon Moon Illustrative Coboy In The Night Desktop Wallpaper  (4).png";
// import Lottie from "lottie-react";
// import project from "../Animation - 1731429503393.json";
import AdsClickRoundedIcon from "@mui/icons-material/AdsClickRounded";
import LightbulbRoundedIcon from "@mui/icons-material/LightbulbRounded";
// import problemimage from "../assets/problem.jpg";
import { useParams } from "react-router-dom";
// import Touchwithme from "./Touchwithme";
// import Footer from "./Footer";

import intripid from "../assets/intripid (1).png";
import intripidfigma from "../assets/intripid.png";

import diehard from "../assets/Die Hard.png";
import diehardfigma from "../assets/Black and Red Gradient Glow Neon Moon Illustrative Coboy In The Night Desktop Wallpaper  (3).png";

import sellwase from "../assets/selwase (1).png";
import sellwasefigma from "../assets/sellwase.png";

import portfolio from "../assets/Profolio.png";
import porfoliofigma from "../assets/Black and Red Gradient Glow Neon Moon Illustrative Coboy In The Night Desktop Wallpaper  (8).png";

import spotify from "../assets/Spotify.png";
import spotifyfigma from "../assets/spotifyfigma.png";

import football from "../assets/football.png";
import footballfigma from "../assets/footballfigma.png";

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faReact } from "@fortawesome/free-brands-svg-icons";
import { faSquareJs } from "@fortawesome/free-brands-svg-icons";
import { faNode } from "@fortawesome/free-brands-svg-icons";
// import { faPython } from "@fortawesome/free-brands-svg-icons";
import { faHtml5 } from "@fortawesome/free-brands-svg-icons";
import { faCss3Alt } from "@fortawesome/free-brands-svg-icons";
import { faFigma } from "@fortawesome/free-brands-svg-icons";
import { faDatabase } from "@fortawesome/free-solid-svg-icons";
import { faCode } from "@fortawesome/free-solid-svg-icons";

import Navbar2 from "./Navbar2";
// import StorageRoundedIcon from '@mui/icons-material/StorageRounded';

const icons = {
  React: {
    icon: <FontAwesomeIcon icon={faReact} className="lg:h-8 sm: h-4" />,
  },
  Css: {
    icon: <FontAwesomeIcon icon={faCss3Alt} className="lg:h-8 sm: h-4" />,
  },
  Html: {
    icon: <FontAwesomeIcon icon={faHtml5} className="lg:h-8 sm: h-4" />,
  },
  Nodejs: {
    icon: <FontAwesomeIcon icon={faNode} className="lg:h-8 sm: h-4" />,
  },
  Js: {
    icon: <FontAwesomeIcon icon={faSquareJs} className="lg:h-8 sm: h-4" />,
  },
  MongoDb: {
    icon: <FontAwesomeIcon icon={faDatabase} className="lg:h-8 sm: h-4" />,
  },
  Figma: {
    icon: <FontAwesomeIcon icon={faFigma} className="lg:h-8 sm: h-4" />,
  },
  Json: {
    icon: <FontAwesomeIcon icon={faCode} className="lg:h-8 sm: h-4" />,
  },
};

const data = {
  Chatnexo: {
    title: "Chatnexo",
    description: "-A Website for Whatsaap web Extension.",
    image: chatnexo,
    figma_image: chatnexofigma,
    link: "https://chatnexo.com/",
    challenges: [
      "Creating dynamic and efficient fetch logic to handle multiple possible filters.",
      "Creating dynamic and efficient fetch logic to handle multiple possible filters.",
      "Simulating database query behaviour with creating use of thecocktaildb.com api.",
    ],
    learnings: [
      "Created dynamic and highly reusable fetching logic by utilising NextJS server actions and React custom hooks.",
      "Effective time management and focus in creating and deploying the project quickly and efficiently.",
      "Set up all the metadata including preview image, title and description as well as favicon.",
      "Acquired deeper understanding in using the ShadCN component library.",
    ],
    techused: [
      "React",
      "Css",
      "Html",
      "MongoDb",
      "Nodejs",
      "Js",
      "Figma",
      "Json",
    ],
  },
  Intripid: {
    title: "Intripid",
    description: "- A Landing Page For Travel Advisor.",
    image: intripid,
    figma_image: intripidfigma,
    link: "https://dev.intripid.co/",
    challenges: [
      "Creating dynamic and efficient fetch logic to handle multiple possible filters.",
      "Creating dynamic and efficient fetch logic to handle multiple possible filters.",
      "Simulating database query behaviour with creating use of thecocktaildb.com api.",
    ],
    learnings: [
      "Created dynamic and highly reusable fetching logic by utilising NextJS server actions and React custom hooks.",
      "Effective time management and focus in creating and deploying the project quickly and efficiently.",
      "Set up all the metadata including preview image, title and description as well as favicon.",
      "Acquired deeper understanding in using the ShadCN component library.",
    ],
    techused: [
      "React",
      "Css",
      "Html",
      "MongoDb",
      "Nodejs",
      "Js",
      "Figma",
      "Json",
    ],
  },

  Diehard: {
    title: "Die Hard",
    description: "- A landing page for Movie review.",
    image: diehard,
    figma_image: diehardfigma,
    link: "https://inspiring-clafoutis-bdc7fd.netlify.app/",
    challenges: [
      "Creating dynamic and efficient fetch logic to handle multiple possible filters.",
      "Creating dynamic and efficient fetch logic to handle multiple possible filters.",
      "Simulating database query behaviour with creating use of thecocktaildb.com api.",
    ],
    learnings: [
      "Created dynamic and highly reusable fetching logic by utilising NextJS server actions and React custom hooks.",
      "Effective time management and focus in creating and deploying the project quickly and efficiently.",
      "Set up all the metadata including preview image, title and description as well as favicon.",
      "Acquired deeper understanding in using the ShadCN component library.",
    ],
    techused: ["React", "Css", "Html", "Js", "Figma", "Json"],
  },
  SellwaseAdmin: {
    title: "Sellwase Admin",
    description: "- Admin Pnnel for Sellwase Application.",
    image: sellwase,
    figma_image: sellwasefigma,
    link: "https://inspiring-clafoutis-bdc7fd.netlify.app/",
    challenges: [
      "Creating dynamic and efficient fetch logic to handle multiple possible filters.",
      "Creating dynamic and efficient fetch logic to handle multiple possible filters.",
      "Simulating database query behaviour with creating use of thecocktaildb.com api.",
    ],
    learnings: [
      "Created dynamic and highly reusable fetching logic by utilising NextJS server actions and React custom hooks.",
      "Effective time management and focus in creating and deploying the project quickly and efficiently.",
      "Set up all the metadata including preview image, title and description as well as favicon.",
      "Acquired deeper understanding in using the ShadCN component library.",
    ],
    techused: [
      "React",
      "Css",
      "Html",
      "MongoDb",
      "Nodejs",
      "Js",
      "Figma",
      "Json",
    ],
  },
  Portfolio: {
    title: "Sellwase Admin",
    description: "- Admin Pnnel for Sellwase Application.",
    image: portfolio,
    figma_image: porfoliofigma,
    link: "https://inspiring-clafoutis-bdc7fd.netlify.app/",
    challenges: [
      "Creating dynamic and efficient fetch logic to handle multiple possible filters.",
      "Creating dynamic and efficient fetch logic to handle multiple possible filters.",
      "Simulating database query behaviour with creating use of thecocktaildb.com api.",
    ],
    learnings: [
      "Created dynamic and highly reusable fetching logic by utilising NextJS server actions and React custom hooks.",
      "Effective time management and focus in creating and deploying the project quickly and efficiently.",
      "Set up all the metadata including preview image, title and description as well as favicon.",
      "Acquired deeper understanding in using the ShadCN component library.",
    ],
    techused: ["React", "Css", "Html", "Js", "Figma", "Json"],
  },
  Spotifyclone: {
    title: "Spotify",
    description: "- A Music website for Streaming of Songs.",
    image: spotify,
    figma_image: spotifyfigma,
    link: "https://spotifyp1000.netlify.app/",
    challenges: [
      "Creating dynamic and efficient fetch logic to handle multiple possible filters.",
      "Creating dynamic and efficient fetch logic to handle multiple possible filters.",
      "Simulating database query behaviour with creating use of thecocktaildb.com api.",
    ],
    learnings: [
      "Created dynamic and highly reusable fetching logic by utilising NextJS server actions and React custom hooks.",
      "Effective time management and focus in creating and deploying the project quickly and efficiently.",
      "Set up all the metadata including preview image, title and description as well as favicon.",
      "Acquired deeper understanding in using the ShadCN component library.",
    ],
    techused: [
      "React",
      "Css",
      "Html",
      "MongoDb",
      "Nodejs",
      "Js",
      "Figma",
      "Json",
    ],
  },
  Football_Highlights: {
    title: "Football Highlights",
    description: "- A website for watch football highlights.",
    image: football,
    figma_image: footballfigma,
    link: "https://footballhilights.netlify.app/",
    challenges: [
      "Creating dynamic and efficient fetch logic to handle multiple possible filters.",
      "Creating dynamic and efficient fetch logic to handle multiple possible filters.",
      "Simulating database query behaviour with creating use of thecocktaildb.com api.",
    ],
    learnings: [
      "Created dynamic and highly reusable fetching logic by utilising NextJS server actions and React custom hooks.",
      "Effective time management and focus in creating and deploying the project quickly and efficiently.",
      "Set up all the metadata including preview image, title and description as well as favicon.",
      "Acquired deeper understanding in using the ShadCN component library.",
    ],
    techused: [
      "React",
      "Css",
      "Html",
      "MongoDb",
      "Nodejs",
      "Js",
      "Figma",
      "Json",
    ],
  },
};

const Casestudybreif = () => {
  const { title } = useParams();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div
      className="h-auto w-full bg-custombg pt-14"
      style={{
        backgroundImage: "radial-gradient(#716d6d 1px, transparent 1px)",
        backgroundSize: "20px 20px",
      }}
    >
      <Navbar2/>
      {/* 1st */}
      <div className="h-auto w-full flex flex-col justify-center items-center p-10">
        <div className="flex flex-col justify-center items-center lg:gap-5 sm: gap-2">
          <p className="text-blue-500 lg:text-2xl sm: text-xs font-semibold">
            WEB DEV PROJECT
          </p>
          <p className="text-yellow-500 lg:text-5xl sm: text-xl font-semibold">
            {" "}
            "{data[title].title}"{" "}
          </p>
          <p className="text-white lg:text-5xl sm: text-sm font-semibold">
            {data[title].description}
          </p>
        </div>

        <div className="lg:h-[90vh] lg:w-3/4 ">
          <img
            src={data[title].image}
            alt=""
            className="h-full w-full object-contain"
          />
        </div>

        {/* <div className="w-3/4 flex justify-center items-center pl-20 pr-20  ">
          <div className="text-white p-4 bg-blue-700 rounded-xl flex justify-center items-center gap-2 ransition delay-100 cursor-pointer hover:scale-105">
            <FontAwesomeIcon icon={faGlobe} className="h-6" />
            <p className="text-xl font-medium">Demo Site</p>
            <FontAwesomeIcon icon={faArrowRight} className="h-5" />
          </div>
        </div> */}
      </div>

      <div className="h-auto w-full flex flex-col items-center justify-center">
        <div className="lg:h-[30vh]  w-full flex flex-col justify-center items-center lg:gap-10">
          <div className="lg:w-3/4 sm: w-full lg:p-0 sm: p-2">
            <p className="text-blue-600 font-semibold lg:text-lg sm: text-xs">
              Way of Work
            </p>
            <p className="text-white font-semibold lg:text-4xl sm: text-xl">
              My Process
            </p>
          </div>
          <div className="lg:w-3/4 sm: w-full flex justify-between items-center lg:p-0 sm: p-2">
            <div className="flex flex-col justify-center items-center gap-2">
              <div className="lg:h-[10vh] lg:w-[10vh] sm: h-[5vh] sm: w-[5vh] text-white flex justify-center items-center bg-blue-900 rounded-full">
                <EditRoadRoundedIcon fontSize="medium" />
              </div>
              <p className="text-white font-semibold lg:text-xl sm: text-xs">
                Definition
              </p>
            </div>
            <div className="flex flex-col justify-center items-center gap-2">
              <div className="lg:h-[10vh] lg:w-[10vh] sm: h-[5vh] sm: w-[5vh] text-white flex justify-center items-center bg-blue-900 rounded-full">
                <ArchitectureRoundedIcon fontSize="medium" />
              </div>
              <p className="text-white font-semibold lg:text-xl sm: text-xs">
                Design
              </p>
            </div>
            <div className="flex flex-col justify-center items-center gap-2">
              <div className="lg:h-[10vh] lg:w-[10vh] sm: h-[5vh] sm: w-[5vh] text-white flex justify-center items-center bg-blue-900 rounded-full">
                <TravelExploreRoundedIcon fontSize="medium" />
              </div>
              <p className="text-white font-semibold lg:text-xl sm: text-xs">
                Planning
              </p>
            </div>
            <div className="flex flex-col justify-center items-center gap-2">
              <div className="lg:h-[10vh] lg:w-[10vh] sm: h-[5vh] sm: w-[5vh] text-white flex justify-center items-center bg-blue-900 rounded-full">
                <WebhookRoundedIcon fontSize="medium" />
              </div>
              <p className="text-white font-semibold lg:text-xl sm: text-xs">
                Development
              </p>
            </div>
            <div className="flex flex-col justify-center items-center gap-2">
              <div className="lg:h-[10vh] lg:w-[10vh] sm: h-[5vh] sm: w-[5vh] text-white flex justify-center items-center bg-blue-900 rounded-full">
                <FlightTakeoffRoundedIcon fontSize="medium" />
              </div>
              <p className="text-white font-semibold lg:text-xl sm: text-xs">
                Deployment
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="h-auto w-full flex flex-col items-center justify-center lg:mb-10 sm: mb-1">
        <div className="w-full flex flex-col justify-center items-center lg:gap-10 sm: gap-2">
          <div className="lg:w-3/4 sm: w-full lg:p-0 sm: p-2">
            <p className="text-blue-600 font-semibold lg:text-lg sm: text-xs">
              Technology Used
            </p>
            <p className="text-white font-semibold lg:text-4xl sm: text-xl">
              Tech Stack Used
            </p>
          </div>

          <div className="lg:w-3/4 sm: w-full flex justify-between items-center lg:p-0 sm: p-2">
            <div className="flex w-full  justify-between items-center gap-1">
              {data[title].techused.map((icon, index) => (
                <div
                  className="flex flex-col justify-center items-center gap-1"
                  key={index}
                >
                  <div className="lg:h-[10vh] lg:w-[10vh] sm: h-[4vh] sm: w-[4vh] text-white flex justify-center items-center bg-blue-900 rounded-full">
                    {icons[icon].icon}
                  </div>
                  <p className="text-white font-semibold lg:text-xl sm: text-xs">{icon}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="h-auto w-full flex flex-col justify-center items-center">
        <div className="lg:h-[10vh] sm: h-[5vh] w-full flex justify-center items-center bg-blue-600 text-white">
          <p className="font-bold lg:text-3xl">HIGH-FIDELITY FIGMA DESIGN</p>
        </div>
        <div className="lg:h-[70vh] sm: h-[30vh] w-full">
          <img
            src={data[title].figma_image}
            alt=""
            className="w-full h-full object-cover opacity-80 "
          />
        </div>
      </div>

      <div className="h-auto w-full flex flex-col items-center justify-center">
        <div className="w-full flex flex-col justify-center items-center gap-10 mt-4">
          {/* <div className="w-3/4">
            <p className="text-blue-600 font-semibold">Problem</p>
            <p className="text-white font-semibold text-4xl">
              Challenges & Learnings
            </p>
          </div> */}

          <div className="lg:w-3/4 sm: w-full lg:p-0 sm: p-2">
            <p className="text-blue-600 font-semibold lg:text-lg sm: text-xs">
            Problem
            </p>
            <p className="text-white font-semibold lg:text-4xl sm: text-xl">
            Challenges & Learnings
            </p>
          </div>

          <div className="lg:w-3/4 sm: w-[90%] bg-gray-900 flex flex-col gap-5 h-auto text-white p-6 rounded-xl">
            <p className="text-red-500 lg:text-lg sm: text-sm font-bold">CHALLENGES</p>
            {data[title].challenges.map((challenge, index) => (
              <div key={index} className="flex items-center gap-3">
                <AdsClickRoundedIcon
                  className="text-red-500"
                  style={{ fontSize: "20px" }}
                />
                <p className="lg:text-lg sm: text-xs font-semibold">{challenge}</p>
              </div>
            ))}
          </div>

          <div className="lg:w-3/4 sm: w-[90%] bg-gray-900 flex flex-col gap-5 h-auto text-white p-6 rounded-xl mb-10">
            <p className="text-green-500 lg:text-lg sm: text-sm font-bold">LEARNINGS</p>

            {data[title].learnings.map((learnings, index) => (
              <div key={index} className="flex items-center gap-3">
                <LightbulbRoundedIcon
                  className="text-green-500"
                  style={{ fontSize: "20px" }}
                />
                <p className="lg:text-lg sm: text-xs font-semibold">{learnings}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* <div className="flex flex-col gap-4">
        <Touchwithme/>
        <Footer/>
      </div> */}

      {/* my process */}
    </div>
  );
};

export default Casestudybreif;
